import React from 'react';
import { useTranslation } from 'react-i18next';
import SingleBlock from './SingleBlock/SingleBlock';
import { Header, Wrapper } from './TopAndBottomEffect.styles';
import { Analysis } from '../../../../../services/reports';

interface TopAndBottomEffectProps {
  data: {
    top?: Analysis | undefined;
    bottom?: Analysis | undefined;
    improved?: Analysis | undefined;
  };
}

const TopAndBottomEffect: React.FC<TopAndBottomEffectProps> = ({ data }) => {
  const { t } = useTranslation();

  const order = ['EFFECT TOP TOPICS', 'EFFECT BOTTOM TOPICS', 'EFFECT MOST IMPROVED'];
  const sortedData = Object.values(data).sort((a, b) => {
    return order.indexOf(a.type) - order.indexOf(b.type);
  });

  const topicsCount = sortedData.filter(
    item => item.included_topics && item.included_topics.length > 0
  ).length;

  return (
    <>
      <Header>{t('report.effect.insights.topAndBottom')}</Header>
      <Wrapper topicsCount={topicsCount}>
        {sortedData.map(item => (
          <SingleBlock key={item.description} data={item} />
        ))}
      </Wrapper>
    </>
  );
};

export default TopAndBottomEffect;
